import { render, staticRenderFns } from "./IntegrationFormTeams.vue?vue&type=template&id=2321cd69&scoped=true"
import script from "./IntegrationFormTeams.vue?vue&type=script&lang=js"
export * from "./IntegrationFormTeams.vue?vue&type=script&lang=js"
import style0 from "./IntegrationFormTeams.vue?vue&type=style&index=0&id=2321cd69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2321cd69",
  null
  
)

export default component.exports